import { type RefObject, useEffect } from "react";
import type { Nullable } from "@/types";

export default function useCursorDrag<T extends HTMLElement>(ref: RefObject<Nullable<T>>) {
    useEffect(() => {
        const abortController = new AbortController();

        ref.current?.addEventListener(
            "mousedown",
            () => {
                if (!ref.current) return;

                ref.current.style.cursor = "grabbing";
            },
            { signal: abortController.signal },
        );

        ref.current?.addEventListener(
            "mouseup",
            () => {
                if (!ref.current) return;

                ref.current.style.cursor = "grab";
            },
            { signal: abortController.signal },
        );

        return () => {
            abortController.abort("unmounting");
        };
    }, [ref]);
}
